module.exports = __webpack_public_path__ + "img/undraw_workout_gcgu_1.424caba5.svg";